import Image from 'next/image'

const BENEFIT_LIST = [
  {
    icon: './images/benefit_image_1.webp',
    iconWidth: 246,
    iconHeight: 246,
    bgColor: 'bg-brand-primary-25',
    title: 'Nhanh chóng',
    descriptions: [
      'Bạn chỉ mất 5 phút để hoàn thành đăng ký vay trên web/app KiotViet quản lý',
      'Hồ sơ vay của bạn sẽ được ngân hàng ưu tiên giải ngân nhanh gấp 2 lần so với thông thường',
    ],
  },
  {
    icon: './images/benefit_image_2.webp',
    title: 'Tiện lợi',
    iconWidth: 317,
    iconHeight: 246,
    bgColor: 'bg-neutral-25',
    descriptions: [
      'Chỉ cần đăng ký online, KiotViet sẽ hỗ trợ bạn thủ tục còn lại',
      'Không cần đến ngân hàng',
      'Không cần giấy tờ chứng minh thu nhập, sử dụng dữ liệu kinh doanh trên phần mềm để thẩm định',
    ],
  },
  {
    icon: './images/benefit_image_3.webp',
    title: 'Lãi suất thấp',
    iconWidth: 235,
    iconHeight: 186,
    bgColor: 'bg-support-success-25',
    descriptions: [
      'Đảm bảo lãi suất thấp nhất mà không cần thế chấp',
      'Nhận được chính sách ưu đãi riêng cho khách hàng của KiotViet',
    ],
  },
]

export default function Benefit() {
  return (
    <div id="loi-ich" className="lg:mt-[94px] mt-[80px] flex justify-center ">
      <div className="max-w-[1920px]">
        <div className="flex flex-col lg:gap-14 gap-10 max-md:px-4">
          <h2
            id="benefit-title"
            className="text-navy text-center lg:text-[30px] !text-6 !font-bold "
          >
            Lý do bạn nên vay vốn qua KiotViet
          </h2>
          <div className="flex flex-col gap-10 items-center ">
            {BENEFIT_LIST.map((benefit, index) => {
              const flexDirection =
                index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
              let size = ' lg:pl-[43.5px] lg:pr-[50.5px] pl-7 pr-[29px]'
              if (index === 1) size = 'w-[317px]'
              if (index === 2) size = ' lg:pl-[53px] lg:pr-[52px] px-[34px]'
              return (
                <div
                  key={benefit.title}
                  className={`flex rounded-[20px] items-center ${benefit.bgColor} ${flexDirection} max-md:flex-col py-6 px-4 gap-6 md:px-6 lg:px-12 lg:gap-[66px] lg:w-[995px] md:w-[705px] w-[343px]`}
                >
                  <div className={`${size} h-[246px]  flex items-center  `}>
                    <Image
                      alt={benefit.title}
                      src={benefit.icon}
                      width={benefit.iconWidth}
                      height={benefit.iconHeight}
                    />
                  </div>
                  <div className="flex flex-col justify-center lg:w-[439px] w-[303px] gap-4">
                    <div className="text-2xl font-bold leading-9 text-text-strong max-md:text-center">
                      {benefit.title}
                    </div>
                    <div className="">
                      <ol className="list-disc m-0">
                        {benefit.descriptions.map((description, index) => {
                          const marginTop = index !== 0 ? 'mt-2' : ''
                          return (
                            <li
                              key={description}
                              className={`${marginTop} text-base font-normal text-text-strong self-stretch list-disc`}
                            >
                              {description}
                            </li>
                          )
                        })}
                      </ol>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
